import { render, staticRenderFns } from "./friendRequest.vue?vue&type=template&id=06482a1b&scoped=true&lang=pug&"
import script from "./friendRequest.vue?vue&type=script&lang=js&"
export * from "./friendRequest.vue?vue&type=script&lang=js&"
import style0 from "./friendRequest.vue?vue&type=style&index=0&id=06482a1b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06482a1b",
  null
  
)

export default component.exports